import React from 'react';

import { toast } from 'bulma-toast';
import server from '../../../../utilities/server';

const HideCategory = ({ modal, setModal, refetch, data }) => {
	const [loading, setLoading] = React.useState(false);

	const _submit = () => {
		setLoading(true);
		server({
			method: 'put',
			path: `products/${data.id}/status`,
		}).then(() => {
			toast({ type: 'is-success', position: 'center', message: 'تمت تحديث المنتج بنجاح' });
			refetch();
			setModal({ });
			setLoading(false);
		}).catch(() => {
			toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء تحديث المنتج' });
			setModal({ });
			setLoading(false);
		});
	}

	return (
		<div id='new-category' className={`modal ${ modal ? 'is-active' : '' }`}>
			<div className='modal-background' onClick={ () => setModal({ }) }></div>
			<div className='modal-card'>
				<header className='modal-card-head'>
					<p className='modal-card-title'>{ data.status === 'draft' ? 'نشر' : 'اخفاء' }  { data.name }</p>
					<a className='delete' aria-label='close' onClick={ () => setModal({ }) }></a>
				</header>
				<div className='modal-card-body'>
					<div className='notification is-warning'>
						{ data.status === 'draft' ?
							'سيتم نشر المنتج وستظهر جميع الصور والاضافات به. هل أنت متأكد من الاستمرار؟'
						: 
							'سيتم اخفاء المنتج وجميع الصور والاضافات به. هل أنت متأكد من الاستمرار؟'
						}
					</div>
				</div>
				<footer className='modal-card-foot'>
					<a type='button' className='button' data-bs-dismiss='modal' onClick={ () => setModal({ }) }>اغلاق</a>
					<button type='button' className='button is-warning' onClick={ _submit } disabled={ loading }>{ data.status === 'draft' ? 'نشر' : 'اخفاء' }</button>
				</footer>
			</div>
		</div>
	)
};

export default HideCategory;
